<template>
  <div
    @click="click"
    class="clickable-div"
  >
    <v-row
      no-gutters
      align="center"
    >
      <div class="d-flex align-center">
        <v-img
          width="80"
          height="80"
          contain
          :src="product.image || '/images/not-found.png'"
        />
      </div>

      <div
        class="text-body-2 ml-4"
        v-text="product.vendor_name || 'Отсутствует'"
      />
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'ProductCell',
    components: {},
    props: {
      product: Object
    },
    methods: {
      click() {
        this.$emit('click')
      }
    }
  }
</script>

<style scoped>
  .clickable-div {
    cursor: pointer;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: background-color 0.2s;
  }

  .clickable-div:hover {
    background-color: #f5f5f5;
  }
</style>
